export default "__VITE_ASSET__DfUk6tLS__"